module.exports = __webpack_public_path__ + "static/media/gh.e0ca5267.svg";